import React from 'react';
import KPITemplate from './KPI_Template';
import '../../../CommonCSS/SocietyCSS.css'

const KPI_TemplateApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>KPI Template</h5>
          </div>
        </div>
        <KPITemplate/>
      </div>
    </div >
  );
};

export default KPI_TemplateApp;
